import React, { useEffect, useState } from 'react';
import { Check, LoaderCircle } from 'lucide-react';
import { Logo } from './Logo';
import { useTranslation } from '../i18n/translations';

export const StrategyResultsSkeleton: React.FC = () => {
  const { t, tx } = useTranslation();
  const [activeStage, setActiveStage] = useState(0);
  const stages = [
    tx('تحليل بيانات المشروع'),
    tx('قراءة إشارات السوق'),
    tx('بناء شرائح الجمهور'),
    tx('تقدير تكلفة الليد CPL'),
    tx('صياغة الاستراتيجية'),
  ];

  useEffect(() => {
    const timer = window.setInterval(() => setActiveStage((stage) => Math.min(stages.length - 1, stage + 1)), 1300);
    return () => window.clearInterval(timer);
  }, [stages.length]);

  return (
    <div className="space-y-6 animate-fadeIn" aria-busy="true" aria-label={t('loading.ariaLabel')}>
      <div className="ai-processing-panel">
        <div className="ai-processing-brand">
          <Logo className="w-11 h-11" tone="light" />
          <div>
            <span>{tx('محرك استهداف يعمل الآن')}</span>
            <h3>{t('loading.building')}</h3>
            <p>{t('loading.eta')}</p>
          </div>
        </div>
        <div className="ai-processing-stages">
          {stages.map((stage, index) => (
            <div key={stage} className={index < activeStage ? 'is-complete' : index === activeStage ? 'is-active' : ''}>
              <span>{index < activeStage ? <Check /> : <LoaderCircle />}</span>
              <p>{stage}</p>
            </div>
          ))}
        </div>
        <div className="ai-processing-progress"><span style={{ width: `${((activeStage + 1) / stages.length) * 100}%` }} /></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="card p-5 space-y-3">
            <div className="skeleton h-4 w-1/3" />
            <div className="skeleton h-3 w-full" />
            <div className="skeleton h-3 w-5/6" />
            <div className="skeleton h-3 w-2/3" />
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[0, 1, 2].map((i) => (
          <div key={i} className="card p-5 space-y-3">
            <div className="skeleton h-5 w-2/3" />
            <div className="skeleton h-20 w-full" />
            <div className="skeleton h-8 w-full !rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export const CardSkeletonRow: React.FC<{ count?: number }> = ({ count = 3 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="card p-4 flex items-center gap-3">
        <div className="skeleton w-10 h-10 !rounded-xl shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="skeleton h-3 w-1/3" />
          <div className="skeleton h-2.5 w-1/2" />
        </div>
      </div>
    ))}
  </div>
);
